import React, { useState, useEffect } from 'react';

const NumberInput = ({ label, value, onChange, min, max, step = 0.1 }) => {
    const [localValue, setLocalValue] = useState(value);
    const [isTyping, setIsTyping] = useState(false);

    useEffect(() => {
        if (!isTyping) {
            setLocalValue(value);
        }
    }, [value, isTyping]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setLocalValue(newValue);

        // If the change is from arrow keys (stepUp/stepDown), update immediately
        if (e.nativeEvent.inputType === 'insertReplacementText' || 
            e.nativeEvent.inputType === 'deleteContentBackward' ||
            e.nativeEvent.inputType === 'insertText') {
            setIsTyping(true);
        } else {
            // Arrow key or spinner change
            const parsedValue = parseFloat(newValue);
            if (!isNaN(parsedValue) && parsedValue >= min && parsedValue <= max) {
                onChange({ target: { value: parsedValue } });
            }
        }
    };

    const handleBlur = () => {
        setIsTyping(false);
        let newValue = parseFloat(localValue);
        if (isNaN(newValue)) {
            newValue = value;
        } else {
            newValue = Math.min(Math.max(newValue, min), max);
        }
        setLocalValue(newValue);
        onChange({ target: { value: newValue } });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    };

    return (
        <div className="flex items-center justify-between space-x-2">
            <label className="text-sm text-gray-600">{label}</label>
            <div className="flex items-center">
                <input
                    type="number"
                    value={localValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setIsTyping(true)}
                    min={min}
                    max={max}
                    step={step}
                    className="w-20 px-2 py-1 text-sm border rounded 
                             focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
                <span className="text-xs text-gray-500 ml-1">{`(${min}-${max})`}</span>
            </div>
        </div>
    );
};

export default NumberInput;